import { offerElementTypeOptions } from '@/assets/locales/views/offerElements/offerElements.common.translation.pl.ts';

export const offerElementsListTranslation = {
  header: {
    button: {
      add: 'Dodaj składową',
    },
  },
  table: {
    body: {
      active: 'Status',
      activeOff: 'Wyłączona',
      activeOn: 'Aktywna',
      currentPrice: 'Cena teraz',
      fromDate: 'od {{date}}',
      method: 'Jak liczymy',
      name: 'Nazwa',
      noPrice: 'brak ceny',
      offerElementType: offerElementTypeOptions,
      type: 'Typ',
      validTo: 'Ważna do',
    },
    browse: {
      button: 'Przeglądaj po kolei ({{count}})',
    },
    details: {
      browseFromHere: 'Przeglądaj od tej',
      category: 'Grupa',
      description: 'Uwagi',
      edit: 'Edytuj',
      element: 'Składowa',
      nextPrices: 'Następny cennik od {{date}}',
      noCategory: 'bez grupy',
      noDescription: 'Brak uwag',
      noPrices: 'Brak cennika na dziś',
      prices: 'Cennik',
      validity: 'Obowiązuje {{from}} – {{to}}',
    },
    head: {
      active: 'Aktywna',
      category: 'Grupa',
      discriminator: 'Rodzaj',
      fullTextSearchInput: 'Wyszukaj',
      manualPricing: 'Wycena indywidualna',
      offerElementType: offerElementTypeOptions,
      priceStatus: 'Cennik',
      priceStatusOptions: {
        ENDING_SOON: 'Kończy się w ciągu 60 dni',
        MISSING_TODAY: 'Brak ceny na dziś',
      },
      type: 'Typ',
    },
    quickFilters: {
      active: 'Aktywne',
      ending: 'Cennik się kończy',
      inactive: 'Wyłączone',
      manual: 'Wycena indywidualna',
      noPrice: 'Bez ceny na dziś',
      type: '{{label}} {{count}}',
    },
  },
};

export type OfferElementsListTranslation = typeof offerElementsListTranslation;
